import ProjectTemplate from '../../components/common/ProjectTemplate';
import PulleyListActionButtons from '../../components/conveyor-pulley/PulleyListActionButtons';
import PulleyListContainer from '../../components/conveyor-pulley/PulleyListContainer';

const PulleyListPage = () => {
    return (
        <ProjectTemplate>
            <PulleyListContainer />
            <PulleyListActionButtons />
        </ProjectTemplate>
    );
};

export default PulleyListPage;
